import ProdDetail from './ProdDetail';

const ACTION = {
  ...ProdDetail.ACTION,
};

const ACTION_TYPES = {
  ...ProdDetail.ACTION_TYPES,
};

const Prod = {
  ACTION,
  ACTION_TYPES
}

export default Prod;